import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';

export const newPasswordResetRequest = (
  password: string,
  token: string
): Promise<void> => {
  const endpoint = endpoints.seller.passwordSet;
  return axiosV2.post(
    endpoint,
    { password: password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
